export class GetMemberListRequest {
  KeywordSearches: string[];
  PageNumber: number;
  ItemsPerPage: number;
  StatusFilter: number;
  Sorting: number;
}
